import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { KeyPersonsService } from '../../services/key-persons.service';

@Component({
  selector: 'app-create-key-persons',
  templateUrl: './create-key-persons.component.html',
  styleUrls: ['./create-key-persons.component.css']
})
export class CreateKeyPersonsComponent implements OnInit {

  parent: string;
  customerOrSupplier: string;

  keyPersonForm: FormGroup;
  keyPerson: any = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private keyPersonsService: KeyPersonsService,
  ) {
    this.parent = this.activatedRoute.parent.snapshot.paramMap.get('id');
    this.customerOrSupplier = this.activatedRoute.parent.snapshot.data['customerOrSupplier'];
  }

  ngOnInit() {
    this.keyPersonForm = this.formBuilder.group({
      name: ['', Validators.required],
      lastName: [''],
      job: [''],
      phone: [''],
      email: ['', Validators.email],
    });
  }

  onSubmitKeyPerson() {
    this.keyPerson = this.saveKeyPerson();

    this.keyPersonsService.addKeyPerson(this.keyPerson);
    this.keyPersonForm.reset();

    if(this.customerOrSupplier == 'customerId'){
      this.router.navigate(['/vw_customer/' + this.parent + '/keyPersons']);
    }else if(this.customerOrSupplier == 'supplierId'){
      this.router.navigate(['/vw_supplier/' + this.parent + '/keyPersons']);
    }
  }
  saveKeyPerson(){
		var customerId = '';
		var supplierId = '';
		if(this.customerOrSupplier == 'customerId') {
			customerId = this.parent;
		} else if (this.customerOrSupplier == 'supplierId'){
			supplierId = this.parent;
    }
    
    const keyPersonJson = {
      customerId: customerId,
      supplierId: supplierId,
      name: this.keyPersonForm.get('name').value,
      lastName: this.keyPersonForm.get('lastName').value,
      job: this.keyPersonForm.get('job').value,
      phone: this.keyPersonForm.get('phone').value,
      email: this.keyPersonForm.get('email').value,
    };

  return keyPersonJson;

  }
  	
	getBack() {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/keyPersons']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/keyPersons']);
		}
	}

}
